<template>
  <div>
    <div v-if="submit_loader" style="position:absolute; top:0; right:0; bottom:0; left:0;
    padding-top: 25%;
      background: radial-gradient(rgba(20, 20, 20,.8), rgba(0,0,0,0.31));
    ">

      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form
                id="create_trip_update"
                @submit.prevent="validateBeforeSubmit('createTripAnnouncement')"
                data-vv-scope="createTripAnnouncement"
                ref="trip_update_form"
                v-model="validateTripUpdate"
            >
              <v-card-text>
                <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                  <v-layout row wrap>
                    <v-flex xs12 md8 lg4>
                      <label>Train Update Type</label>
                      <v-autocomplete
                          :items="announcement_types"
                          name="Train Update Type"
                          label="Select Train Update Type"
                          v-model="announcement_object.type"
                          return-object
                          item-text="title"
                          @change="resetInput"
                          item-value="id"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('createTripAnnouncement.Announcement Type')"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md8 lg4>
                      <label>Train Code</label>
                      <v-autocomplete
                          :items="train_codes"
                          v-model="announcement_object.train_code"
                          name="Announcement Type"
                          label="Select Train Code"
                          return-object
                          :item-text="getItemText"
                          item-value="number"
                          solo flat multiple chips deletable-chips
                          :menu-props="{closeOnContentClick:true}"
                          :disabled="![1, 3, 5, 7, 8].includes(Number((announcement_object.type && announcement_object.type.id) || 0))"
                          @paste.native.prevent="handleTrainCodePaste($event)"
                      >
                      </v-autocomplete>
                    </v-flex>

<!--                    <v-flex xs12 md8 lg4>-->
<!--                      <label>Affected Date</label>-->
<!--                      <flat-pickr-->
<!--                          class="flatpickerCSS2"-->
<!--                          v-model="announcement_object.affected_date"-->
<!--                          :config="config"-->
<!--                          placeholder="Date"-->
<!--                          name="Relevant from"/>-->
<!--                    </v-flex>-->
                  </v-layout>

                  <!--                    <v-layout row wrap>-->
                  <!--                      <v-flex xs12 md6 lg8>-->
                  <!--                        <label>Type: </label>-->
                  <!--                        <v-text-field-->
                  <!--                            name="type"-->
                  <!--                            v-model="announcement_object.announcement_type"-->
                  <!--                            v-validate="'required'"-->
                  <!--                            solo flat-->
                  <!--                            :error-messages="errors.collect('createTripAnnouncement.announcement_type')"-->
                  <!--                            readonly-->
                  <!--                        >-->
                  <!--                        </v-text-field>-->
                  <!--                      </v-flex>-->
                  <!--                    </v-layout>-->

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg9>
                      <label>Short Description: </label>
                      <v-textarea
                          name="Short_Description"
                          v-model="announcement_object.short_description"
                          rows="2"
                          solo flat
                          :error-messages="errors.collect('createTripAnnouncement.Short_Description')"
                          clearable>
                      </v-textarea>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap v-if="[7, 8].includes(Number((announcement_object.type && announcement_object.type.id) || 0))">
                    <v-flex xs12 md6 lg4>
                      <label>Temporary End Station Code</label>
                      <v-autocomplete
                          :items="local_stations"
                          name="temporary_end_station_code"
                          v-model="announcement_object.temporary_end_station_code"
                          :item-text="getStationItemText"
                          item-value="code"
                          label="Select Temporary End Station"
                          solo flat>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md6 lg9>
                      <label>Reason</label>
                      <v-textarea
                          name="reason"
                          v-model="announcement_object.reason"
                          rows="2"
                          solo flat>
                      </v-textarea>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg9 v-if="bulk_selection == false">
                      <label>Description: </label>
                      <v-textarea
                          name="Description"
                          v-model="announcement_object.long_description"
                          rows="2"
                          solo flat
                          :error-messages="errors.collect('createTripAnnouncement.Description')"
                          readonly>
                      </v-textarea>
                    </v-flex>


                    <v-flex xs12 md6 lg9 v-if="bulk_selection == true">
                        <label class="heading">Description : </label>
                        <ul>
                          <li v-for="(item) in announcement_object_ids" :key="item.number">
<!--                            <span><b>{{"Train Number : "}}</b> {{item.number}}</span><br />-->
                            <span><b>{{"Description : "}}</b> {{item.long_description}}</span>
                            <br /><br />
                          </li>
                        </ul>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" small v-if="this.announcement_object.type.id == '1' ||
                  this.announcement_object.type.id == '5'"
                       :disabled="(announcement_object.short_description == '' ||
                  announcement_object.train_code.number == '' || announcement_object.type == '')"
                       @click="confirm_to_publish_announcement_dialog = true">Create
                </v-btn>

                <v-btn color="primary" small v-if="this.announcement_object.type.id == '3'"
                       :disabled="((announcement_object.short_description == '' ||
                  announcement_object.train_code.number == '' || announcement_object.type == '') ||
                  (/\d/.test((announcement_object.short_description).slice(-20)) != true))"
                       @click="confirm_to_publish_announcement_dialog = true">Create
                </v-btn>

                  <v-btn color="primary" small v-if="this.announcement_object.type.id == '7' || this.announcement_object.type.id == '8'"
                    :disabled="(
                      announcement_object.short_description == '' ||
                      announcement_object.type == '' ||
                      !announcement_object.train_code ||
                      announcement_object.train_code.length == 0 ||
                      announcement_object.temporary_end_station_code == '' ||
                      announcement_object.reason == ''
                    )"
                    @click="confirm_to_publish_announcement_dialog = true">Create
                  </v-btn>

                <v-btn flat small to="/trip-announcements">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>

      </v-layout>


      <!--      <v-dialog v-model="publish_message_dialog" scrollable :overlay="false" max-width="450px"-->
      <!--                transition="dialog-transition" persistent>-->
      <!--        <v-card>-->
      <!--          <v-card-title primary-title>-->
      <!--            <span class="subheading">{{ publish_message }}</span>-->
      <!--          </v-card-title>-->

      <!--          <v-card-actions>-->
      <!--            <v-spacer></v-spacer>-->
      <!--            <v-btn small color="primary" @click="redirectAnnouncement()">Ok</v-btn>-->
      <!--          </v-card-actions>-->
      <!--        </v-card>-->
      <!--      </v-dialog>-->

      <v-dialog v-model="confirm_to_publish_announcement_dialog" scrollable :overlay="false" max-width="450px"
                transition="dialog-transition" persistent>
        <v-card>
          <v-card-title primary-title>
            <br>

            <v-flex xs12 md12><br/></v-flex>

            <span class="subheading">Do you want to publish this Train Update ?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small @click="confirm_to_publish_announcement_dialog = false, confirm_button_loader=false">No</v-btn>
            <v-btn small color="primary" type="submit" @click="createTripAnnouncement()"
                   :loading="confirm_button_loader">Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>

    <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
      {{ snackbar.message }}
      <v-btn
          text
          dark
          @click="snackbar.display = false"
      >
        <v-icon
            right
            color="white"
        >
          close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "Create",
  components:{
    flatPickr
  },
  watch: {
    "announcement_object.train_code": function (val) {
      if (val != '' && this.announcement_object.type != '') {
        if (this.announcement_object.type.id == 1 || this.announcement_object.type.id == 3 ||
            this.announcement_object.type.id == 5 || this.announcement_object.type.id == 7 ||
            this.announcement_object.type.id == 8) {
          if ((this.announcement_object.train_code).length > 1) {
            this.announcement_object_ids = [];

            this.populate_announcement();
            this.bulk_selection = true;
          } else {
            this.bulk_selection = false;
            this.populate_announcement();
          }
        }
        if (this.announcement_object.type.id == 1) {
          this.announcement_object.short_description = "Cancelled";
        } else if (this.announcement_object.type.id == 3) {
          this.announcement_object.short_description = "";
        } else if (this.announcement_object.type.id == 5) {
          this.announcement_object.short_description = "";
        } else if (this.announcement_object.type.id == 7) {
          this.announcement_object.short_description = "";
        } else if (this.announcement_object.type.id == 8) {
          this.announcement_object.short_description = "";
        }
      }else{
        this.announcement_object_ids = [];

        this.announcement_object.short_description = "";
        this.announcement_object.long_description = "";
      }
    },
    "announcement_object.short_description": {
      immediate: true, // Update immediately on component mount
      handler(val) {
        if (val != '') {
          this.announcement_object_ids.forEach((element) => {
            this.announcement_object.long_description = element.old;

            this.announcement_object.long_description = this.announcement_object.long_description +
                this.computed_short_description;

            element.long_description = this.announcement_object.long_description;

          });

          // this.announcement_object.long_description = this.populated_announcement;
          // this.announcement_object.long_description = this.announcement_object.long_description+
          //     this.computed_short_description;
          //
          //
          // this.cache_announcement_long_description = this.announcement_object.long_description;
        }

      }
    },
  },
  data() {
    return {
      submit_loader: false,
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 3000
      },
      announcement_object: {
        type: "",
        train_code: [],
        short_description: "",
        long_description: "",
        title: "",
        dummy_long_description: "",
        affected_date: '',
        temporary_end_station_code: '',
        reason: '',
        schedule_start_time: ''
      },
      announcement_object_ids: [],
      local_lines: [],
      local_stations: [],
      train_codes: [],
      announcement_types: [],
      validateTripUpdate: '',
      confirm_to_publish_announcement: '',
      confirm_to_publish_announcement_dialog: false,
      announcement_status: '',
      announcement_id: '',
      cache_announcement_title: '',
      cache_announcement_long_description: '',
      publish_message_dialog: false,
      publish_message: '',
      confirm_button_loader: false,
      cache_announcement_id: '',
      populated_announcement: '',
      bulk_selection: false,
      result: {},
      announcement_ids: [],
      config: {
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        time_24hr: false,
        minDate: moment().format('YYYY-MM-DD'),
      }
    }
  },
  methods: {
    validateBeforeSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    resetInput() {
      this.announcement_object.train_code = '';
      this.announcement_object.local_line = '';
      this.announcement_object.short_description = '';
      this.announcement_object.long_description = '';
      this.announcement_object.affected_date = moment().format('YYYY-MM-DD');
      this.announcement_object.temporary_end_station_code = '';
      this.announcement_object.reason = '';
      this.announcement_object.schedule_start_time = '';
      this.populated_announcement = '';
      this.bulk_selection = false;
      // this.getLocalLineList();
      // this.getTypeList();
      this.getTrainCodes();
    },
    getTypeList() {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/wa-announcer/announcement-types`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.announcement_types = response.data.types;
              this.announcement_object.type = this.announcement_types[0];
            }
          })
    },
    getTrainCodes: function () {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-codes`,
          {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.train_codes = response.data.train_codes;
            }

          })
    },
    getLocalStations() {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-local-stations`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.local_stations = response.data.stations || [];
            }
          });
    },
    populate_announcement: function () {
      // this.submit_loader = true;
      this.announcement_object_ids = [];
      this.announcement_object.long_description = "";
      this.announcement_object.short_description = "";
      this.announcement_object.schedule_start_time = "";
      this.startLoading();

      let new_announcement = {}; //Object.assign({},this.announcement_object);
      new_announcement.announcement_type_id = this.announcement_object.type.id;
      new_announcement.train_number = this.announcement_object.train_code;
      this.populated_announcement = '';
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/populate-announcement-template`,
          new_announcement, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              const currentTypeId = Number((this.announcement_object.type && this.announcement_object.type.id) || 0);
              const isShortTerminateOrExtended = [7, 8].includes(currentTypeId);
              const responseData = Array.isArray(response.data.data) ? response.data.data : [];
              const needsHydration = (row) => {
                const desc = String((row && row.long_description) || '').trim();
                return desc === '' || this.isGenericFallbackDescription(desc);
              };

              const hydrateRows = (rows) => {
                this.announcement_object_ids = rows;
                const firstScheduleStartTime = this.getScheduleStartTimeFromRows(rows);
                this.announcement_object.schedule_start_time = firstScheduleStartTime;

                this.announcement_object_ids.forEach((element) => {
                  if (!element.long_description || String(element.long_description).trim() === '') {
                    element.long_description = this.getFallbackBaseDescription(element.number);
                  }

                  element.old = element.long_description;
                  this.announcement_object.long_description = element.long_description;
                  this.announcement_object.long_description = this.announcement_object.long_description +
                      this.computed_short_description;
                  element.title = element.title || this.getFallbackTitle();
                  this.announcement_object.title = element.title;
                  element.long_description = element.long_description + this.computed_short_description;
                });

                this.submit_loader = false;
                this.stopLoading();
              };

              const shouldHydrateWithTrainDetails = isShortTerminateOrExtended &&
                  (responseData.length === 0 || responseData.some((row) => needsHydration(row)));

              if (shouldHydrateWithTrainDetails) {
                this.buildShortTerminationAnnouncementRows()
                    .then((detailedRows) => {
                      if (responseData.length === 0) {
                        hydrateRows(detailedRows);
                        return;
                      }

                      const detailedByNumber = detailedRows.reduce((acc, row) => {
                        acc[String(row.number)] = row;
                        return acc;
                      }, {});

                      const mergedRows = responseData.map((row) => {
                        const rowNumber = String((row && row.number) || '');
                        const detail = detailedByNumber[rowNumber];
                        if (!detail || !needsHydration(row)) {
                          return row;
                        }
                        return {
                          ...row,
                          title: row.title || detail.title,
                          long_description: detail.long_description,
                        };
                      });

                      hydrateRows(mergedRows);
                    })
                    .catch(() => hydrateRows(this.getFallbackAnnouncementRows()));
              } else {
                hydrateRows(responseData);
              }
            } else {
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }
          }).catch((error) => {
        console.log(error);
      }).finally(() => {
        // this.submit_loader =  false;
        this.stopLoading();
      });
    },
    handleTrainCodePaste(event) {
      const pastedText = (event.clipboardData || window.clipboardData).getData('text') || '';

      // Supports: comma/newline values, "98806 - B 6", and short-code only values like "B 6"
      const normalizeCode = (value) => String(value || '')
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '');

      const segments = pastedText
          .split(/[\n,;]+/)
          .map(s => s.trim())
          .filter(Boolean);

      const lookupTokens = [];

      segments.forEach(segment => {
        const numberMatches = segment.match(/\b\d{5}\b/g) || [];
        numberMatches.forEach(number => lookupTokens.push({type: 'number', value: number.trim()}));

        if (segment.includes('-')) {
          const codePart = segment.split('-').slice(1).join('-').trim();
          const normalizedCodePart = normalizeCode(codePart);
          if (normalizedCodePart) {
            lookupTokens.push({type: 'code', value: normalizedCodePart});
          }
        }

        if (numberMatches.length === 0) {
          const normalizedSegment = normalizeCode(segment);
          if (normalizedSegment) {
            lookupTokens.push({type: 'code', value: normalizedSegment});
          }
        }
      });

      const currentSelection = Array.isArray(this.announcement_object.train_code)
          ? [...this.announcement_object.train_code]
          : [];

      const alreadySelectedNumbers = currentSelection.map(item => String(item.number).trim());

      lookupTokens.forEach(token => {
        const matched = this.train_codes.find(tc => {
          if (token.type === 'number') {
            return String(tc.number).trim() === token.value;
          }
          return normalizeCode(tc.short_code) === token.value;
        });

        if (matched) {
          const matchedNumber = String(matched.number).trim();
          if (!alreadySelectedNumbers.includes(matchedNumber)) {
            currentSelection.push(matched);
            alreadySelectedNumbers.push(matchedNumber);
          }
        }
      });

      this.announcement_object.train_code = currentSelection;
    },
    getItemText(item) {
      return `${item.number} - ${item.short_code}`;
    },
    getFallbackTitle() {
      const typeId = Number((this.announcement_object.type && this.announcement_object.type.id) || 0);
      if (typeId === 7) return 'Short Terminated';
      if (typeId === 8) return 'Extended';
      return 'Train Update';
    },
    isGenericFallbackDescription(description) {
      return /^Train\s+\d+\s*-\s*.*:\s*$/i.test(String(description || '').trim());
    },
    getScheduleStartTimeFromRows(rows) {
      if (!Array.isArray(rows)) return '';

      const firstRowWithSchedule = rows.find((row) => {
        const direct = String((row && row.schedule_start_time) || '').trim();
        const fallback = String((row && row.scheduled_departure_time) || '').trim();
        return direct !== '' || fallback !== '';
      });

      if (!firstRowWithSchedule) return '';

      return String(
          firstRowWithSchedule.schedule_start_time ||
          firstRowWithSchedule.scheduled_departure_time ||
          ''
      ).trim();
    },
    async buildShortTerminationAnnouncementRows() {
      const selectedTrains = Array.isArray(this.announcement_object.train_code)
          ? this.announcement_object.train_code
          : [];

      const requests = selectedTrains.map((train) =>
          axios.get(`${process.env.VUE_APP_API_URL}/api/v1/local-trains/${train.number}/details`, {headers: this.$headers})
      );

      const responses = await Promise.all(requests);

      return responses.map((res, index) => {
        const details = (((res || {}).data || {}).data) || {};
        const selected = selectedTrains[index] || {};

        const trainNumber = details.number || selected.number;
        const speed = details.speed ? `(${details.speed})` : '';
        const firstStation = details.first_station_name || '';
        const lastStation = details.last_station_name || selected.short_code || '';
        const schedule = Array.isArray(details.train_schedules_by_order) ? details.train_schedules_by_order : [];
        const startTimeRaw = schedule.length ? schedule[0].time : '';
        const formattedTime = startTimeRaw
            ? moment(startTimeRaw, ['HH:mm:ss', 'HH:mm']).format('hh:mm A')
            : '';

        const routePrefix = `${formattedTime} ${lastStation}${speed}`.trim();
        return {
          number: trainNumber,
          title: `${routePrefix} : ${this.getFallbackTitle()}`.trim(),
          long_description: `${routePrefix} local from ${firstStation} : `.replace(/\s+/g, ' ').trimStart(),
          schedule_start_time: startTimeRaw,
        };
      });
    },
    getFallbackBaseDescription(trainNumber) {
      const matchedTrain = this.train_codes.find((train) => String(train.number) === String(trainNumber));
      const trainLabel = matchedTrain
          ? `${matchedTrain.number} - ${matchedTrain.short_code}`
          : `${trainNumber}`;
      return `Train ${trainLabel} : `;
    },
    getFallbackAnnouncementRows() {
      const selectedTrains = Array.isArray(this.announcement_object.train_code)
          ? this.announcement_object.train_code
          : [];

      return selectedTrains.map((train) => ({
        number: train.number,
        title: this.getFallbackTitle(),
        long_description: this.getFallbackBaseDescription(train.number),
        schedule_start_time: '',
      }));
    },
    getStationItemText(item) {
      if (!item) return '';
      return `${item.name} (${item.code})`;
    },
    createTripAnnouncement() {
      this.confirm_button_loader = true;
      const currentTypeId = Number((this.announcement_object.type && this.announcement_object.type.id) || 0);
      const isShortTerminateOrExtended = [7, 8].includes(currentTypeId);

      const result = this.announcement_object_ids.map((element) => {
        const payload = {
          ...element,
          train_number: element.number,
          type: this.announcement_object.type,
          short_description: this.announcement_object.short_description,
          affected_date: this.announcement_object.affected_date,
        };

        if (isShortTerminateOrExtended) {
          payload.short_termination = {
            train_number: String(element.number || ''),
            service_date: this.announcement_object.affected_date,
            scheduled_departure_time: String(element.schedule_start_time || this.announcement_object.schedule_start_time || ''),
            temporary_end_station_code: this.announcement_object.temporary_end_station_code,
            reason: this.announcement_object.reason
          };
        }

        return payload;
      });

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/store-trip-announcement`, {data: result},
          {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.announcement_ids = response.data.announcement_id;
              this.updateStatus();
            } else if (response.data.status == 0) {
              this.confirm_button_loader = false;
              this.confirm_to_publish_announcement_dialog = false;
              this.status_model = false;
              this.snackbar.display = true;
              this.snackbar.message = response.data.message;
              this.resetInput();
            }
          }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.submit_loader = false;
      });
    },
    updateStatus: function () {
      this.announcement_status = "Publish";

      const currentTypeId = Number((this.announcement_object.type && this.announcement_object.type.id) || 0);
      const isShortTerminateOrExtended = [7, 8].includes(currentTypeId);

      const result = this.announcement_ids.map((element) => {
        const payload = {
          ...element,
          status: this.announcement_status,
        };

        if (isShortTerminateOrExtended) {
          payload.short_termination = {
            service_date: this.announcement_object.affected_date,
            scheduled_departure_time: String(element.schedule_start_time || this.announcement_object.schedule_start_time || ''),
            temporary_end_station_code: this.announcement_object.temporary_end_station_code,
            reason: this.announcement_object.reason,
          };
        }

        return payload;
      });

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/publish-announcement`,
          {data: result}, {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.confirm_to_publish_announcement_dialog = false;
          this.confirm_button_loader = false;
          this.status_model = false;
          this.snackbar.display = true;
          this.snackbar.message = response.data.message;
          this.announcement_object_ids = [];
          this.resetInput();
          this.getTypeList();

          // this.$router.push({name: 'trip-announcements', params: {message: response.data.message}});

        }
        if (response.data.status == 2) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }

      }).catch((error) => {

      }).finally(() => {

      });
    },
    redirectAnnouncement() {
      this.$router.push({name: 'trip-announcements'});
    },
  },
  computed: {
    computed_short_description() {
      return this.announcement_object.short_description == null ? '' : this.announcement_object.short_description;

    }
  },
  mounted() {
    this.getTypeList();
    this.getTrainCodes();
    this.getLocalStations();
    this.announcement_object.affected_date = moment().format('YYYY-MM-DD');
  },
}
</script>

<style scoped>

</style>
